import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../../utils/apolloClient';
import config from '../../../utils/config';

const initialState = {
  dataTransactions: undefined,
  isDataTransactionsLoading: false,
  hasDataTransactionsError: false
};

export const getDataTransactions = createAsyncThunk(
  'getDataTransactions',
  async ({dealerOrgIds, connectCdkToken, token}) => {
    let response = await client.authorizeRequest({
      method: 'POST',
      url: `${config.serviceEndpoints.mpDpMetadataUrl}/last-transactions`,
      data: {
        dealerOrgIds, connectCdkToken
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
);

export const dataTransactions = createSlice({
  name: 'dataTransactions',
  initialState,
  reducers: {},
  extraReducers: {
    [getDataTransactions.fulfilled]: (state, action) => {
    state.dataTransactions = action.payload || [];
    state.isDataTransactionsLoading = false;
    state.hasDataTransactionsError = false;
    },
    [getDataTransactions.pending]: (state, action) => {
      state.dataTransactions = undefined;
      state.isDataTransactionsLoading = true;
      state.hasDataTransactionsError = false;
    },
    [getDataTransactions.rejected]: (state, action) => {
      state.dataTransactions = undefined;
      state.isDataTransactionsLoading = false;
      state.hasDataTransactionsError = true;
    }
  }
});

export default dataTransactions.reducer;